import React from 'react'

const HomeIcon = React.forwardRef((props, ref) => (
  <svg width="37" height="37" viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
    <path d="M3.15305 19.6037V36.1912H13.7246V27.1844C13.7246 27.1844 13.7246 22.8955 18.0136 22.8955C22.3025 22.8955 22.3025 27.1844 22.3025 27.1844V36.1912H32.5752V19.6037C26.7959 13.8244 23.5684 10.5969 17.8641 4.89262C12.1598 10.672 8.93239 13.8994 3.15305 19.6037Z" fill="#FFD15C"/>
    <path d="M35.3517 16.3623L19.6649 0.67551C18.7642 -0.22517 17.188 -0.22517 16.2873 0.67551L0.67551 16.3623C-0.22517 17.263 -0.22517 18.8392 0.67551 19.7399C1.57619 20.6405 3.15238 20.6405 4.05306 19.7399L18.0136 5.77934L31.9741 19.7399C32.8748 20.6405 34.451 20.6405 35.3517 19.7399C36.2524 18.7642 36.2524 17.263 35.3517 16.3623Z" fill="#E91E63"/>
  </svg>
))

export default HomeIcon 